//v2.0 - DataLoader is a facade over native fetch (previously axios).
//All loaders that need AJAX-style loading extend this. Subclasses receive an
//axios-shaped `{ data }` response object, so their contract is unchanged.
import { Loader } from './Loader';

export abstract class DataLoader extends Loader {
	public url;
	public method: string = 'GET';
	public data: any = null;

	public load(): void {
		this._load();
	}

	//protected
	//--------------------------------------------------------

	protected dataLoadComplete(data: any): void {
		this.complete(data);
	}

	//private
	//--------------------------------------------------------

	private _load() {
		const isGet = this.method === 'GET';

		let url: string = this.url;
		if (isGet && this.data) {
			const query = new URLSearchParams(this.data).toString();
			if (query) {
				url += (url.indexOf('?') !== -1 ? '&' : '?') + query;
			}
		}

		fetch(url, {
			method: this.method,
			body: isGet || this.data == null ? undefined : JSON.stringify(this.data),
			headers: isGet || this.data == null ? undefined : { 'Content-Type': 'application/json' }
		})
			.then(async (response) => {
				//axios rejected on non-2xx; reproduce that
				if (!response.ok) {
					throw new Error(`HTTP ${response.status} loading ${url}`);
				}
				const contentType = response.headers.get('content-type') || '';
				const data = contentType.indexOf('application/json') !== -1 ? await response.json() : await response.text();
				return { data };
			})
			.then((response) => {
				this.dataLoadComplete(response);
			})
			.catch((error) => {
				this.error(error);
			});
	}
}
